import kmMessages from '../locales/km-KH';

const KmLang = {
    messages: {
        ...kmMessages
    },
    locale: 'km-KH',
};

export default KmLang;